
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import { Action } from 'vuex-class';

    const namespace = 'main';

    @Component
    export default class WhoHasAccess extends Vue {
        @Prop({ default: null }) public modelAccess: any;
        @Prop({ default: null }) public model: any;
        @Action('closeModelAccess', { namespace }) closeModelAccess: any;

        private modalShow = false;

        private mounted() {
            this.$on('escKey' + this.$options.name, () => {
                if (this.modalShow) this.close();
            });
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") this.$emit('escKey' + this.$options.name);
            });
        }

        @Watch('modelAccess')
        private onModelAccessChanged(value: any) {
            this.modalShow = value != null;
        }

        private get roles(): any[] {
            return this.modelAccess ? this.modelAccess.roles : [];
        }

        private get users(): any[] {
            return this.modelAccess ? this.modelAccess.users : [];
        }

        // The group(s) that grant `roleName` to `user` on this model — empty when the user lacks the role.
        private grantingGroups(user: any, roleName: string): string[] {
            const match = (user.roles || []).find((r: any) => r.roleName === roleName);
            return match ? match.grantedByGroups : [];
        }

        private close() {
            this.closeModelAccess();
        }
    }
